export default "__VITE_ASSET__DrgwQ_5r__"